import { cn } from "../../lib/cn";

interface Props {
  label: string;
  value: string;
  className?: string;
  icon?: React.ReactNode;
  hint?: string;
}

export function Stat({ label, value, icon, hint, className }: Props) {
  return (
    <div
      className={cn(
        "flex flex-col gap-0.5 rounded-2xl bg-white ring-1 ring-ink-200 px-3 py-2.5",
        className
      )}
    >
      <div className="flex items-center gap-1.5 text-caption uppercase tracking-wide text-ink-400 font-medium">
        {icon}
        <span>{label}</span>
      </div>
      <div className="text-body font-semibold tabular-nums text-ink-900">{value}</div>
      {hint && <div className="text-caption text-ink-400">{hint}</div>}
    </div>
  );
}
